import { Outlet, useNavigate, NavLink } from 'react-router-dom';
import { LogOut, History, Swords } from 'lucide-react';
import { useSession } from '@/store/sessionStore';
import { Avatar } from '@/design-system/components/Avatar';
import { t } from '@/lib/i18n';
import styles from './UserLayout.module.css';

export default function UserLayout() {
  const { user, logout } = useSession();
  const navigate = useNavigate();

  return (
    <div className={styles.root}>
      <header className={styles.nav}>
        <div className={styles.navInner}>
          <button className={styles.logoBtn} onClick={() => navigate('/lobby')}>
            <svg width="24" height="24" viewBox="0 0 40 40" fill="none">
              <rect width="40" height="40" rx="10" fill="var(--color-primary)" />
              <text x="20" y="27" textAnchor="middle" fill="white" fontSize="20" fontWeight="700">D6</text>
            </svg>
            <span className={styles.logoText}>{t('common.appName')}</span>
          </button>

          <nav className={styles.navLinks}>
            <NavLink
              to="/lobby"
              className={({ isActive }) =>
                `${styles.navLink} ${isActive ? styles.navLinkActive : ''}`
              }
            >
              {t('userLayout.navLobby')}
            </NavLink>
            <NavLink
              to="/rps-rooms"
              className={({ isActive }) =>
                `${styles.navLink} ${isActive ? styles.navLinkActive : ''}`
              }
            >
              <Swords size={14} />
              {t('userLayout.navRpsRooms')}
            </NavLink>
            <NavLink
              to="/history"
              className={({ isActive }) =>
                `${styles.navLink} ${isActive ? styles.navLinkActive : ''}`
              }
            >
              <History size={14} />
              {t('userLayout.navHistory')}
            </NavLink>
          </nav>

          <div className={styles.userMenu}>
            {user && (
              <>
                <Avatar
                  src={user.avatar_url ?? undefined}
                  name={user.display_name ?? user.email}
                  size="sm"
                />
                <span className={styles.userName}>{user.display_name ?? user.email}</span>
              </>
            )}
            <button className={styles.logoutBtn} onClick={logout} title={t('common.logout')}>
              <LogOut size={16} />
            </button>
          </div>
        </div>
      </header>

      <main className={styles.content}>
        <Outlet />
      </main>
    </div>
  );
}
